// Shared decimal.js setup for quantity and money maths. Internal: not exported publicly.
import Decimal from 'decimal.js';

/**
 * Private Decimal constructor: 60 significant digits so add/sub/mul are exact for any
 * realistic quantity or amount, independent of anyone changing the global Decimal config.
 */
export const D = Decimal.clone({
  precision: 60,
  rounding: Decimal.ROUND_HALF_UP,
  toExpNeg: -60,
  toExpPos: 60,
});

/**
 * Rounding modes used by money and quantity maths.
 * - `half_up`: nearest; ties away from zero (2.5 → 3, −2.5 → −3). The default.
 * - `half_even`: nearest; ties to the even neighbour (banker's rounding).
 * - `down`: towards zero (truncate).
 * - `up`: away from zero.
 */
export type RoundingMode = 'half_up' | 'half_even' | 'down' | 'up';

/** Maps a {@link RoundingMode} to decimal.js's constant. */
export function decimalRounding(mode: RoundingMode): Decimal.Rounding {
  switch (mode) {
    case 'half_up':
      return Decimal.ROUND_HALF_UP;
    case 'half_even':
      return Decimal.ROUND_HALF_EVEN;
    case 'down':
      return Decimal.ROUND_DOWN;
    case 'up':
      return Decimal.ROUND_UP;
  }
}
